import { gql } from '@apollo/client';

const CONTACTS = gql`
  query contacts(
    $masterEntity_In: [ID]
    $orderBy: String
    $first: Int
    $offset: Int
    $contactType: String
    $showHidden: Boolean
    $source_In: [String]
  ) {
    getContacts(
      masterEntity_In: $masterEntity_In
      orderBy: $orderBy
      first: $first
      offset: $offset
      contactType_Code: $contactType
      showHidden: $showHidden
      source_In: $source_In
    ) {
      edges {
        node {
          id
          name
          position
          email
          phoneNumber
          source
          contactType {
            code
          }
          masterEntity {
            id
          }
          userInstance {
            id
            activeInvitations {
              companyFrom {
                id
                rut
              }
            }
          }
        }
      }
    }
  }
`;

export default CONTACTS;
